import styled from 'styled-components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Helmet } from 'react-helmet-async';
import BaseLayout from '../../components/BaseLayout';
import Header from '../../components/Header';
import { FormContainer } from '../../components/FormContainer/FormContainer';
import ButtonPrimary from '../../components/Buttons/Button';
import {
  selectPortalUrl,
  selectSettings,
} from '../../store/selectors/settingsSelectors';
import { PAGES } from '../../constants/pages';
import { retrieveFromSessionStorage } from '../../util/helpers/sessionStorageHelper';
import {
  ACCOUNT_TYPE_GTM,
  IS_UPGRADE_FLOW,
} from '../../constants/sessionStorage';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';
import { useApplicantData } from '../../hooks/useApplicantData';

const CTAContainer = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media only screen and (max-width: 500px) {
    width: 100%;
    bottom: 40px;
  }
`;

const KycDone = () => {
  const { t } = useTranslation();
  const ApplicantData = useApplicantData();
  const portalUrlApi = useSelector(selectPortalUrl);
  const location = useLocation();
  const { BrokerName } = useSelector(selectSettings);
  const isUpgradeFlowFromDashboard = retrieveFromSessionStorage(
    IS_UPGRADE_FLOW,
  );

  const portalUrl = !isUpgradeFlowFromDashboard
    ? `${portalUrlApi}?flow=regular`
    : portalUrlApi;

  const { gtmStepEvent } = useGtmStepHook();
  const accountGtmType = retrieveFromSessionStorage(ACCOUNT_TYPE_GTM);

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'Kyc done',
      accountType: accountGtmType,
      accountName: ApplicantData?.PersonName,
      accountDateOfBirth: ApplicantData?.PersonBirthday,
      accountPhone: ApplicantData?.Phone,
      accountAddress: ApplicantData?.PersonAddress,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'Kyc done',
      accountType: accountGtmType,
      accountName: ApplicantData?.PersonName,
      accountDateOfBirth: ApplicantData?.PersonBirthday,
      accountPhone: ApplicantData?.Phone,
      customParams: {
        timestamp: new Date().toISOString(),
      },
    });
  };

  return (
    <BaseLayout canGoBack={false}>
      <Helmet>
        <title>
          {t('kycDone.titleTag', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Header
        title={
          location.pathname === PAGES.KYC_DONE
            ? t('kycDone.title')
            : t('kycDone.titleSkip')
        }
        subtitle={
          location.pathname === PAGES.KYC_DONE
            ? t('kycDone.subtitle')
            : t('kycDone.subtitleSkip')
        }
        subTitleMb={24}
      />
      <FormContainer mt="auto">
        <CTAContainer>
          <ButtonPrimary
            title={t('kycSuccess.goto')}
            onClick={() => {
              handleGtmEvent();
              window.location.replace(portalUrl);
            }}
          />
        </CTAContainer>
      </FormContainer>
    </BaseLayout>
  );
};

export default KycDone;
